module.exports = __webpack_public_path__ + "img/cracker-banana-vignette.368b6631.jpg";